(function() {
  const section = document.querySelector('.periodic-table-eleven-section');
  if (!section) return;

  const buttons = section.querySelectorAll('.periodic-table-filter-btn');
  const tableGrid = section.querySelector('.periodic-table-grid');
  const filteredGrid = section.querySelector('.periodic-table-filtered-grid');
  const filteredCards = filteredGrid.querySelectorAll('.periodic-card');
  const tableCards = tableGrid.querySelectorAll('.periodic-card');

  // Filter logic
  buttons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const filter = this.getAttribute('data-filter');

      buttons.forEach(function(b) { b.classList.remove('periodic-table-filter-btn--active'); });
      this.classList.add('periodic-table-filter-btn--active');
      section.setAttribute('data-active-filter', filter);

      if (filter === 'all') {
        tableGrid.style.display = '';
        filteredGrid.style.display = 'none';
        tableCards.forEach(function(card) {
          card.style.animation = 'none';
          card.offsetHeight;
          card.style.animation = 'periodicFadeIn 0.4s ease forwards';
        });
      } else {
        tableGrid.style.display = 'none';
        filteredGrid.style.display = '';

        // Sort filtered cards by their data-number attribute
        var cardsArray = Array.prototype.slice.call(filteredCards);
        cardsArray.sort(function(a, b) {
          return (parseInt(a.getAttribute('data-number'), 10) || 0) - (parseInt(b.getAttribute('data-number'), 10) || 0);
        });
        cardsArray.forEach(function(card) {
          filteredGrid.appendChild(card);
        });

        filteredCards.forEach(function(card) {
          if (card.getAttribute('data-category') === filter) {
            card.style.display = '';
            card.style.animation = 'none';
            card.offsetHeight;
            card.style.animation = '';
          } else {
            card.style.display = 'none';
          }
        });
      }
    });
  });

  // Drawer logic
  const drawer = document.getElementById('PeriodicDrawer');
  if (!drawer) return;

  var handleProductWheel = function(e) {
    var scroller = e.target.closest('.periodic-drawer__products-scroll');
    if (!scroller) return;
    if (scroller.scrollWidth <= scroller.clientWidth) return;
    if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
    if (e.deltaY === 0) return;
    scroller.scrollLeft += e.deltaY;
    e.preventDefault();
  };

  drawer.addEventListener('wheel', handleProductWheel, { passive: false });

  const populatedCards = section.querySelectorAll('.periodic-card--populated');
  populatedCards.forEach(function(card) {
    card.addEventListener('click', function(e) {
      e.stopPropagation();
      const elementNumber = this.getAttribute('data-number');
      const template = section.querySelector('template[data-element-template="' + elementNumber + '"]');
      if (template) {
        // Re-query drawer internals fresh each time (drawer may have moved to body)
        var drawerHeader = drawer.querySelector('.drawer__header');
        var drawerContent = drawer.querySelector('#PeriodicDrawerContent');
        var closeBtn = drawerHeader ? drawerHeader.querySelector('.drawer__close') : null;

        // Populate header (element info before close button)
        var headerTemplate = template.content.querySelector('template[data-drawer-header]');
        // Remove any previously injected header content
        if (drawerHeader) {
          var oldHeaderContent = drawerHeader.querySelectorAll('.periodic-drawer__header-row');
          oldHeaderContent.forEach(function(el) { el.remove(); });
        }
        if (headerTemplate && drawerHeader) {
          if (closeBtn) {
            drawerHeader.insertBefore(headerTemplate.content.cloneNode(true), closeBtn);
          } else {
            drawerHeader.appendChild(headerTemplate.content.cloneNode(true));
          }
        }

        // Populate content (description + products)
        if (drawerContent) {
          var contentTemplate = template.content.querySelector('template[data-drawer-content]');
          drawerContent.innerHTML = '';
          if (contentTemplate) {
            drawerContent.appendChild(contentTemplate.content.cloneNode(true));
          }
        }
      }
      drawer.show();
    });
  });
})();
